import {Component, input} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {FieldContainerComponent} from '@shared/form/field-container/field-container.component';
import {StringFieldBaseComponent} from '@shared/form/string/string-field-base.component';
import {CharsLeftComponent} from '@shared/form/string/chars-left/chars-left.component';

@Component({
  selector: 'app-string-field',
  imports: [
    ReactiveFormsModule,
    FieldContainerComponent,
    CharsLeftComponent
  ],
  templateUrl: './string-field.component.html',
  styleUrl: './string-field.component.scss'
})
export class StringFieldComponent extends StringFieldBaseComponent {

  public readonly charsLeftThreshold = input(5);

}
